import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { LoginView } from '@/react/auth/LoginView/LoginView';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { withReactQuery } from '@/react-tools/withReactQuery';

export const authModule = angular
  .module('portainer.app.react.views.auth', [])
  .component(
    'loginView',
    r2a(withUIRouter(withReactQuery(LoginView)), ['onLoginSuccess'])
  ).name;
